import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledUnknownEmailContainer = styled.div`
    justify-content: center;

    .container {
        .container-header {
            display: grid;

            .containerTitle {
                margin-bottom: 7rem;
                font-size: var(--size-32);
                font-style: normal;
                font-weight: bold;
                line-height: 48px;
                color: var(--color-primary);
                text-align: center;
                @media ${breakpoints.sm} {
                    margin-bottom: 3.5rem;
                    font-size: var(--size-18);
                    line-height: 40px;
                }
            }

            .message {
                align-items: center;
                margin-bottom: 2.8rem;
                font-size: var(--size-16);
                font-style: normal;
                font-weight: normal;
                line-height: 22px;
                color: var(--color-grey-900);
                text-align: center;
            }
        }

        .container-body {
            text-align: left;

            .blue-text {
                font-size: var(--size-16);
                font-style: normal;
                font-weight: bold;
                line-height: 22px;
                color: var(--color-primary);
                text-align: center;
            }

            .grey-text {
                display: flex;
                align-items: center;
                margin-top: 2.4rem;
                margin-bottom: 0.4rem;
                font-size: var(--size-16);
                font-weight: bold;
                line-height: 22px;
            }

            .button {
                margin-top: 1.6rem;
            }

            .emailSeparator {
                display: flex;
                align-items: center;
                margin-top: 3rem;
                margin-bottom: 3rem;

                .loginSep {
                    top: 371px;
                    left: 989px;
                    width: 42.5%;
                    height: 0;
                    border: 1px solid var(--color-grey-700);
                }

                .orLabel {
                    width: 15%;
                    font-size: var(--size-12);
                    font-style: normal;
                    font-weight: normal;
                    line-height: 16px;
                    color: var(--color-grey-800);
                    text-align: center;
                }
            }
        }
    }
`;
